// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1AK-R","Open":"SideDrawer_Open__3vThe","Close":"SideDrawer_Close__3rZKd","Logo":"SideDrawer_Logo__20PF4"};